export enum EinreichungOutlet {
  Dialog = 'dialog',
  Overlay = 'overlay',
  Popup = 'popup',
}
